import { networkService } from "../components/config/axios";

export const LEGAL_TITLES = {
  privacy: "Privacy Notice",
  terms: "Terms of Service",
};

export const LEGAL_LANGUAGES = [
  { code: "en", name: "English", locale: "en-GB" },
  { code: "de", name: "Deutsch", locale: "de-DE" },
  { code: "es", name: "Español", locale: "es-ES" },
];

export const LEGAL_COPY = {
  en: {
    titles: { privacy: "Privacy Notice", terms: "Terms of Service" },
    leads: {
      privacy: "How we collect, use and protect personal data across our Services, and the rights you have over it.",
      terms: "The rules for using our websites and Services, and what you agree to when you use them.",
    },
    onThisPage: "On this page",
    print: "Print",
    language: "Language",
    effective: "Effective",
    lastReviewed: "Last reviewed",
    version: "Version",
    loading: "Loading…",
    loadFailed: "This document could not be loaded. Please try again later.",
    fallback: (language) => `This document is not yet available in ${language}. You are reading the English version.`,
    reviewedOn: (date) => `You reviewed this Privacy Notice on ${date}.`,
  },
  de: {
    titles: { privacy: "Datenschutzhinweis", terms: "Nutzungsbedingungen" },
    leads: {
      privacy: "Wie wir personenbezogene Daten in unseren Diensten erheben, nutzen und schützen und welche Rechte Sie daran haben.",
      terms: "Die Regeln für die Nutzung unserer Websites und Dienste und wozu Sie sich mit der Nutzung verpflichten.",
    },
    onThisPage: "Auf dieser Seite",
    print: "Drucken",
    language: "Sprache",
    effective: "Gültig ab",
    lastReviewed: "Zuletzt geprüft",
    version: "Version",
    loading: "Wird geladen…",
    loadFailed: "Dieses Dokument konnte nicht geladen werden. Bitte versuchen Sie es später erneut.",
    fallback: () => "Dieses Dokument ist noch nicht auf Deutsch verfügbar. Sie lesen die englische Fassung.",
    reviewedOn: (date) => `Sie haben diesen Datenschutzhinweis am ${date} gelesen.`,
  },
  es: {
    titles: { privacy: "Aviso de privacidad", terms: "Condiciones del servicio" },
    leads: {
      privacy: "Cómo recopilamos, utilizamos y protegemos los datos personales en nuestros Servicios, y los derechos que tiene sobre ellos.",
      terms: "Las normas para usar nuestros sitios web y Servicios, y lo que acepta al utilizarlos.",
    },
    onThisPage: "En esta página",
    print: "Imprimir",
    language: "Idioma",
    effective: "En vigor desde",
    lastReviewed: "Última revisión",
    version: "Versión",
    loading: "Cargando…",
    loadFailed: "No se ha podido cargar este documento. Inténtelo de nuevo más tarde.",
    fallback: () => "Este documento todavía no está disponible en español. Está leyendo la versión en inglés.",
    reviewedOn: (date) => `Revisó este Aviso de privacidad el ${date}.`,
  },
};

export const legalLanguage = (code) => LEGAL_LANGUAGES.find((language) => language.code === code) || LEGAL_LANGUAGES[0];

export const legalCopy = (code) => LEGAL_COPY[legalLanguage(code).code];

const cache = {};

export const fetchLegalDocument = (kind, language = "en") => {
  const key = `${kind}:${language}`;
  if (!cache[key]) {
    cache[key] = networkService(`legal_documents/${kind}.json?lang=${encodeURIComponent(language)}`, "GET")
      .then((response) => response.data)
      .catch((error) => {
        delete cache[key];
        throw error;
      });
  }
  return cache[key];
};

export const formatLegalDate = (value, language = "en") => {
  if (!value) return null;
  const parsed = new Date(/^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T00:00:00` : value);
  if (isNaN(parsed.getTime())) return null;
  return parsed.toLocaleDateString(legalLanguage(language).locale, { year: "numeric", month: "long", day: "numeric" });
};
